import { APIResponseType } from 'requestApi';
import { fetchUrl } from './constant';
import request from '@/utils/request';
import type { SearchPagination } from '@/types/common';

/* available map */
export async function searchSkuInfoList(params: object) {
  const res = await request.get(fetchUrl['sku_search'], {
    params,
  });
  return res;
}

export interface SearchSkuInfoDetailQuery {
  sku_id?: string;
}

/**
 * SKU 详情（data 含 ref_shop_list 等字段）
 * YAPI: GET /api/v2/apps/basic/sku/sku_detail
 */
export async function searchSkuInfoDetail(params: SearchSkuInfoDetailQuery) {
  const res = await request.get(fetchUrl['sku_detail'], {
    params,
  });
  return res;
}

export async function getMtskuAttachmentList(params: object) {
  /* PermissionKey: PC.WMSBasic.SKUItem */
  const res = await request.get(fetchUrl['get_mtsku_attachment_list'], {
    params,
  });
  return res;
}

export async function updateSkuInfoDetail(
  params: object,
  requestConfig?: object
) {
  const res = await request.post(
    fetchUrl['sku_detail_update'],
    {
      ...params,
    },
    requestConfig || {}
  );
  return res;
}

export async function searchSkuInfoHistory(params: object) {
  const res = await request.get(fetchUrl['sku_detail_history'], {
    params,
  });
  return res;
}

export async function searchRuleGroup(params: object) {
  const res = await request.get(fetchUrl['search_rule_group'], {
    params: {
      ...params,
    },
  });
  return res;
}

export async function getSkuVolume(params: object) {
  const res = await request.get(fetchUrl['get_sku_volume'], {
    params: {
      ...params,
    },
  });
  return res;
}

//当前未传参数（视为0），获取的是内包材
// 0 内包材
// 1 外包材
interface InterfaceQueryConsumablesSelection {
  type_mode: 0 | 1;
}

export async function queryConsumablesSelection(
  params?: InterfaceQueryConsumablesSelection
) {
  /* PermissionKey: ALL */
  return await request.get(
    '/api/v2/apps/process/outbound/consumables/query_consumables',
    {
      params: {
        ...params,
      },
    }
  );
}

/** SKU Group */
export interface ApiV2AppsBasicSkugroupSearchSkuGroupQuery {
  sku_group_id?: string;
  sku_group_name?: string;
  sku_id?: string;
  operator?: string;
  mtime_from?: number;
  mtime_to?: number;
  pageno?: number;
  count?: number;
}
export interface ApiV2AppsBasicSkugroupSearchSkuGroupResponse {
  data?: {
    count?: number;
    /**
     * SearchSkuGroupItem
     */
    list?: {
      mtime?: number;
      operator?: string;
      sku_group_id?: string;
      sku_group_name?: string;
    }[];
    pageno?: number;
    total?: number;
  };
  message?: string;
  retcode?: number;
}

export async function searchSkuGroup(
  params: ApiV2AppsBasicSkugroupSearchSkuGroupQuery
): Promise<ApiV2AppsBasicSkugroupSearchSkuGroupResponse> {
  /* PermissionKey: PC.WMSBasic.SKUItem.SKUGroup.View */
  const res = await request.get(
    '/api/v2/apps/basic/skugroup/search_sku_group',
    {
      params,
    }
  );
  return res;
}

/* Query 请求的参数只做为参考，请仔细核对类型 */

export interface ApiV2AppsBasicSkugroupSearchSkuGroupDetailQuery {
  sku_group_id?: string;
  sku_id?: string;
  pageno?: number;
  count?: number;
}
export interface ApiV2AppsBasicSkugroupSearchSkuGroupDetailResponse {
  data?: {
    count?: number;
    /**
     * SearchSkuGroupDetailItem
     */
    list?: {
      sku_id?: string;
      sku_name?: string;
    }[];
    pageno?: number;
    total?: number;
  };
  message?: string;
  retcode?: number;
}
export async function searchSkuGroupDetail(
  params: ApiV2AppsBasicSkugroupSearchSkuGroupDetailQuery
): Promise<ApiV2AppsBasicSkugroupSearchSkuGroupDetailResponse> {
  /* PermissionKey: PC.WMSBasic.SKUItem.SKUGroup.Action.View */
  const res = await request.get(
    '/api/v2/apps/basic/skugroup/search_sku_group_detail',
    {
      params,
    }
  );
  return res;
}

export interface ApiV2AppsBasicSkugroupUpdateSkuGroupRequest extends FormData {
  excel_file?: {};
  sku_group_id?: string;
  sku_group_name?: string;
  sku_id_list?: string[];
}
export interface ApiV2AppsBasicSkugroupUpdateSkuGroupResponse {
  data?: {};
  message?: string;
  retcode?: number;
}
export async function updateSkuGroup(
  params: ApiV2AppsBasicSkugroupUpdateSkuGroupRequest
): Promise<ApiV2AppsBasicSkugroupUpdateSkuGroupResponse> {
  /* PermissionKey: PC.WMSBasic.SKUItem.SKUGroup.Action.Edit */
  const res = await request.post(
    '/api/v2/apps/basic/skugroup/update_sku_group',
    params
  );
  return res;
}

export interface ApiV2AppsBasicSkugroupCreateSkuGroupRequest extends FormData {
  excel_file?: {};
  sku_group_name?: string;
}
export interface ApiV2AppsBasicSkugroupCreateSkuGroupResponse {
  data?: {};
  message?: string;
  retcode?: number;
}
export async function createSkuGroup(
  params: ApiV2AppsBasicSkugroupCreateSkuGroupRequest
): Promise<ApiV2AppsBasicSkugroupCreateSkuGroupResponse> {
  /* PermissionKey: PC.WMSBasic.SKUItem.SKUGroup.Create */
  const res = await request.post(
    '/api/v2/apps/basic/skugroup/create_sku_group',
    params
  );
  return res;
}

export async function deleteSkuGroup(params: {
  confirmed: number; // 0-No; 1-Yes
  sku_group_id: string;
}): Promise<
  APIResponseType<{
    /**
     * DeleteSkuGroupRefItem，有引用该sku group的列表
     */
    ref_list?: {
      ref_id?: string;
      /**
       * 引用了shop group的业务类型，见枚举：BasicDataRefRefType
       */
      ref_type?: number;
    }[];
  }>
> {
  /* PermissionKey: PC.WMSBasic.SKUItem.SKUGroup.Action.Delete */
  const res = await request.post(
    '/api/v2/apps/basic/skugroup/delete_sku_group',
    params
  );
  return res;
}

export async function getSkuGroupUploadTemplate() {
  /* PermissionKey: PC.WMSBasic.SKUItem.SKUGroup.Action.Edit */
  const res = await request.get(
    '/api/v2/apps/basic/skugroup/get_sku_group_upload_template'
  );
  return res;
}

export async function getNewSkuAdoUploadList(params: SearchPagination): Promise<
  APIResponseType<{
    data: {
      id: number;
      whs_id: string;
      task_status: number;
      upload_file_link: string;
      result_file_link: string;
      fail_reason: string;
      operator: string;
      ctime: number;
      mtime: number;
    }[];
    total: number;
  }>
> {
  /* PermissionKey: PC.WMSBasic.SKUItem.Upload */
  return await request.get(fetchUrl['get_new_sku_ado_upload_list'], {
    params: {
      ...params,
    },
  });
}

export async function getSkuUploadLogList(params: SearchPagination) {
  /* PermissionKey: PC.WMSBasic.SKUItem.Upload */
  return await request.get('/api/v2/apps/basic/sku/get_sku_upload_log_list', {
    params: {
      ...params,
    },
  });
}
